import type { DirectMessage } from '../../core/models/DirectMessage';
import type { Language } from '../../types';

export function directMessageToNotification(
  message: DirectMessage,
  lang: Language,
) {
  const es = lang === 'es';
  return {
    id: `msg_${message.id}`,
    cat: 'messages' as const,
    sev: 'info' as const,
    urgent: false,
    unread: !message.read,
    title: message.subject || (es ? 'Nuevo mensaje' : 'New message'),
    body: `${message.fromName}: ${message.body}`,
    meta: {
      messageId: message.id,
      fromUserId: message.fromUserId,
      fromName: message.fromName,
    },
  };
}
